import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as me from '../../feature'

import { getActionsConfig } from './actions'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages all the current core contexts, such as current tenant, zone, app,
 * scenario, etc.
 */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(parent: me.Feature) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Employee',
      parent,
      selectors: () => new Selectors(this),
    })
  }
}
